<template>
  <div :class="$style.container">
    <div :class="$style.content">

      <div :class="$style.logo" @click="handleOnInformationShowing">
        <project-logo
          :logo-link="projectLogo"
          :project-name="projectName"
        />
      </div>

      <div :class="$style.information">
        <div :class="$style.name" @click="handleOnInformationShowing">
          {{ projectName }}
        </div>

        <div :class="$style.category">
          <project-category
            :source="projectUrl"
            :category="projectCategory"
          />
        </div>
      </div>

      <div v-if="language" :class="$style.language">
        <localization-controller :language="language" />
      </div>
    </div>

    <project-information-modal
      v-if="isShownProjectInformation"
      :project="project"
      @hide="handleOnInformationClosing"
    />
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import ProjectLogo from './components/ProjectLogo';
import ProjectCategory from './components/ProjectCategory';
import ProjectInformationModal from './components/ProjectInformationModal';

import LocalizationController from 'organisms/localization/LocalizationController';

export default {
  name: 'ProjectHeader',
  components: {
    ProjectLogo,
    ProjectCategory,
    ProjectInformationModal,
    LocalizationController,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
    language: {
      type: Object,
    },
  },
  data() {
    return {
      isShownProjectInformation: false,
    };
  },
  computed: {
    projectLogo() {
      return this.project.projectLogo || this.project.project_logo;
    },
    projectName() {
      return this.project.projectName || this.project.project_name;
    },
    projectCategory() {
      return this.project.projectCategory || this.project.project_category;
    },
    projectUrl() {
      return this.project.projectUrl || this.project.project_url;
    },
    projectDescription() {
      return this.project.projectDescription || this.project.project_description;
    },
  },
  methods: {
    handleOnInformationShowing() {
      this.isShownProjectInformation = true;
      disableBodyScroll(document.body);
    },
    handleOnInformationClosing() {
      this.isShownProjectInformation = false;
      enableBodyScroll(document.body);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    width: 100%
    position: relative
    z-index: 1000

  .content
    display: flex
    align-items: center

  .logo
    flex: none
    align-self: flex-start
    margin-right: 15px
    cursor: pointer

  .information
    flex: 1
    overflow: hidden

  .name
    font-weight: 600
    font-size: 18px
    line-height: 22px
    cursor: pointer

  .category
    margin-top: 4px

  .language
    flex: none
    align-self: flex-start
    padding: 10px
    cursor: pointer
</style>
